export default __webpack_public_path__ + "static/lutein-zeaxanthin-ringelblume-makula-56eaa9987d9092d30bdf200d4ba35a06.jpg";